import { render, staticRenderFns } from "./AdsPopup.vue?vue&type=template&id=36fbcc9b&scoped=true"
import script from "./AdsPopup.vue?vue&type=script&lang=js"
export * from "./AdsPopup.vue?vue&type=script&lang=js"
import style0 from "./AdsPopup.vue?vue&type=style&index=0&id=36fbcc9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbcc9b",
  null
  
)

export default component.exports